import React from 'react'
// ##
import TagsTable from '../../modules/Tag/components/TagsTable'

export default function TagPage() {
  return <TagsTable />
}
